import React from 'react';
import { HiDesktopComputer, HiMoon, HiSun } from 'react-icons/hi';
import { useTheme } from '../context/ThemeContext';

const options = [
  { id: 'light', label: 'Light', icon: HiSun },
  { id: 'dark', label: 'Dark', icon: HiMoon },
  { id: 'system', label: 'System', icon: HiDesktopComputer },
];

/**
 * Segmented appearance toggle: light / dark / follow system.
 */
const ThemeSegmentedControl = ({ className = '' }) => {
  const { theme, setTheme } = useTheme();

  return (
    <div
      className={`inline-flex rounded-xl border p-1 gap-0.5 ${className}`.trim()}
      style={{
        borderColor: 'var(--app-border)',
        background: 'var(--app-surface-strong)',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      }}
      role="group"
      aria-label="Color theme"
    >
      {options.map(({ id, label, icon: Icon }) => {
        const active = theme === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => setTheme(id)}
            className="flex items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-sm font-semibold transition-colors duration-150 min-w-0"
            style={{
              color: active ? 'var(--app-accent-strong)' : 'var(--app-muted)',
              background: active ? 'var(--app-accent-soft)' : 'transparent',
            }}
            aria-pressed={active}
            title={label}
          >
            <Icon className="w-4 h-4 shrink-0" aria-hidden />
            <span className="hidden sm:inline">{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ThemeSegmentedControl;
